// This function exists because we can't listen to location.reload in a test environment..
// ..without hacks, so we listen to a mock of this function instead
export const reload = () => {
  window.location.reload();
};
